import { Engine1Proxy } from 'com-gyf-webcore-servicehub';

let IngresoCobranzaManager = function () {

    const dataSourceCobranza = 'EVENTSOURCING_TRANSACTION_COBRANZA';
    const dataSourceCobranzaVisa = 'EVENTSOURCING_TRANSACTION_COBRANZA_VISA';

    /**
     * 
     * @param {any} cobranza
     * @param {any} viewCallback
     */
    function _guardarCobranza(cobranza, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = mapearCobranza(cobranza);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceCobranza, 'Tarjetas', feature, null, isQuery, null, deleteInstance, id);
        Engine1Proxy.Execute((data) => _guardarCobranzaVisa(data, viewCallback), null, null, feature);
    }

    /**
     * 
     * @param {any} data
     * @param {any} viewCallback
     */
    function _guardarCobranzaVisa(data, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = {
            "COBRANZA_ID": data.EVENTSOURCING_TRANSACTION_COBRANZA
        };
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceCobranzaVisa, 'Tarjetas', feature, null, isQuery, null, deleteInstance, id);
        Engine1Proxy.Execute(viewCallback, null, null, feature);
    }

    /**
     * 
     * @param {any} cobranza
     * @param {any} viewCallback
     */
    function _actualizarCobranza(cobranza, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = mapearCobranza(cobranza);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceCobranza, 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, cobranza.Id);
        Engine1Proxy.Execute(viewCallback, null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} cobranza
     * @param {any} viewCallback
     */
    function _eliminarCobranza(cobranza, viewCallback) {
        let isQuery = false;
        let deleteInstance = false;
        const localValues = mapearCobranza(cobranza);
        Engine1Proxy.AddEventSourcingDataRequest(localValues, dataSourceCobranza, 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, cobranza.Id);
        Engine1Proxy.Execute(viewCallback, null, null, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} cobranza
     */
    function mapearCobranza(cobranza) {
        let values = {
            "ID": cobranza.Id,
            "ENTIDAD_BANCO_EMISOR_ID": cobranza.EntidadBancoEmisorId,
            "SUCURSAL_ID": cobranza.SucursalId,
            "CUENTA_TARJETA_ID": cobranza.CuentaTarjetaId,
            "CUENTA_TARJETA_SALDO_ID": cobranza.CuentaTarjetaSaldoId,
            "FECHA_CREACION": cobranza.FechaCreacion,
            "FECHA_COBRANZA": cobranza.FechaCobranza,
            "FECHA_PRESENTACION": cobranza.FechaPresentacion,
            "FECHA_CIERRE": cobranza.FechaCierre,
            "FECHA_PROCESADOR_ADINTAR": cobranza.FechaProcesadoAdintar,
            "FECHA_PROCESADOR_ADMINISTRADORA": cobranza.FechaProcesoAdministradora,
            "FECHA_CAMBIO_ESTADO": cobranza.FechaCambioEstado,
            "COBRANZA_ESTADO_ID": cobranza.CobranzaEstadoId,
            "COBRANZA_MONEDA_ID": cobranza.CobranzaMonedaId,
            "IMPORTE": cobranza.Importe,
            "COBRANZA_ORIGEN_ID": cobranza.CobranzaOrigenId,
            "COBRANZA_MODO_INGRESO": cobranza.CobranzaModoIngreso,
            "FORMA_PAGO_ID": cobranza.FormaPagoId,
            "CARGADO_POR_ADMINISTRADORA": cobranza.CargadoPorAdministradora,
            "COBRANZA_CARTERA_ID": cobranza.CobranzaCarteraId,
            "FECHA_INFORMA_EMERIX": cobranza.FechaInformaEmerix
        };
        return values;
    }

    return {
        GuardarCobranza: function (cobanza, viewCallback) {
            return _guardarCobranza(cobanza, viewCallback);
        },
        ActualizarCobranza: function (cobanza, viewCallback) {
            return _actualizarCobranza(cobanza, viewCallback);
        },
        EliminarCobranza: function (cobranza, viewCallback) {
            return _eliminarCobranza(cobranza, viewCallback);
        }
    }
};

let ingresoCobranzaManager = new IngresoCobranzaManager();
export default ingresoCobranzaManager;